import envConfigMapping from '@/config/env/envConf.json';
import {supreme, _} from '@/supreme-core';

export default {
  getEnv(){
    // 0 qa 1 uat 2 stg 3 prod
    var url = location.host;
    var code;

    if (url.indexOf('-qa.') != -1 || url.indexOf('-dev.') != -1){
      code = 0;
    } else if (url.indexOf('-test.') != -1 || url.indexOf('localhost') != -1 || url.indexOf('-local') != -1){
      code = 1;
    } else if (url.indexOf('-stg.') != -1){
      code = 2;
    } else {
      code = 3;
    }
    // code = 0;
    return code;
  },

  /**
   * @params 对应的配置文件的名称
   * */
  getEnvInfo(name){
    var e = envConfigMapping;

    switch (this.getEnv()){
    case 0:
      return e.qa;
    case 1:
      return e.sit;
    case 2:
      return e.stg;
    case 3:
      return e.prod;
    default:
      return e.qa;
    }
  },

  // 是否在app 的webview 中，浏览器，微信，微博等载体不算
  isInWebview (){
    return navigator.userAgent.indexOf('_dsbridge') > -1;
  },
  // 兼容刘海屏手机
  isIphoneX(){
    // if (this.newVersion()) {
    //   let osinfo = supreme.localCache.get("getOSInfo");
    //   return osinfo && osinfo['device_type'] == 'ios' && osinfo['is_iphonex_type'] ? true : false;
    // }
    // let getOSInfo = JSON.parse(supreme.localCache.get("getOSInfo"));
    // if (getOSInfo && getOSInfo['mobileinfo']['isIPhoneXType']) {
    //   return true;
    // }
    return false;
  },
  // 判断在老的webview框架下
  isHybrid(){
    return navigator.userAgent.indexOf('vom_nio_app_ios') > -1 || navigator.userAgent.indexOf('vom_nio_app_android') > -1;
  },

  getQueryVariable(variable){
    var query = window.location.search.substring(1);
    var vars = query.split('&');

    for (var i = 0; i < vars.length; i++){
      var pair = vars[i].split('=');

      if (pair[0] == variable){
        return pair[1];
      }
    }
    return false;
  },

  formatCurrency: function (s){
    let n = 2;

    n = n > 0 && n <= 20 ? n : 2;
    s = `${parseFloat(`${s}`.replace(/[^\d\.-]/g, '')).toFixed(n)}`;
    let l = s.split('.')[0].split('').reverse();
    let r = s.split('.')[1];
    let t = '';

    for (let i = 0; i < l.length; i++){
      t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? ',' : '');
    }
    // return t.split("").reverse().join("") + "." + r;
    //不保留小数
    return t.split('').reverse().join('');
  },
  toNum(a){
    a.toString();
    //也可以这样写 var c=a.split(/\./);
    var c = a.split('.');
    var num_place = ['', '0', '00', '000', '0000']; var
      r = num_place.reverse();

    for (var i = 0; i < c.length; i++){
      var len = c[i].length;

      c[i] = r[len] + c[i];
    }
    var res = c.join('');

    return res;
  },
  // cprVersionNew(version = ''){
  //   // 版本比较
  //   let appInfo = dsBridge.hasNativeMethod("common.getAppInfo") && dsBridge.call("common.getAppInfo", "");
  //   //传参不能为空/取App版本不能为空
  //   if (version == '' || !appInfo || appInfo.version == '蔚来') {
  //     return false;
  //   }
  //
  //   // appInfo={
  //   //   version:'4.2.4'
  //   // }
  //   let _a = this.toNum(appInfo.version),//当前包的版本
  //     _b = this.toNum(version); //传入版本
  //
  //   let flag = false
  //   _a = parseInt(_a);
  //   _b = parseInt(_b);
  //   // 默认比较 app版本号 大于等于 传入比较版本号
  //   if (_a >= _b) {
  //     flag = true
  //   } else {
  //     flag = false
  //   }
  //   return flag
  // },

  /**
   * 水平缓动滚动
   * @param scroller 当前滚动对象
   * @param position 滚动条滚动到x轴position的位置
   */
  scrollSmoothToX(scroller, position){
    if (!window.requestAnimationFrame){
      window.requestAnimationFrame = function (callBack, Element){
        return setTimeout(callBack, 17);
      };
    }
    // 当前滚动宽度
    var {scrollLeft} = scroller;
    // 滚动step方法
    var step = function (){
      // 距离目标滚动距离
      var distance = position - scrollLeft;
      // 目标滚动位置

      scrollLeft = scrollLeft + distance / 5;
      if (Math.abs(distance) < 1){
        scroller.scrollTo(position, 0);
      } else {
        scroller.scrollTo(scrollLeft, 0 );
        requestAnimationFrame(step);
      }
    };

    step();
  },
  /**
   * 上下缓动滚动
   * @param scroller 当前滚动对象
   * @param position 滚动条滚动到Y轴position的位置
   */
  scrollSmoothToY(scroller, position){
    if (!window.requestAnimationFrame){
      window.requestAnimationFrame = function (callback, element){
        return setTimeout(callback, 17);
      };
    }
    // 当前滚动高度
    var {scrollTop} = scroller;
    // 滚动step方法
    var step = function (){
      // 距离目标滚动距离
      var distance = position - scrollTop;
      // 目标滚动位置

      scrollTop = scrollTop + distance / 5;
      if (Math.abs(distance) < 1){
        scroller.scrollTo(0, position);
      } else {
        scroller.scrollTo(0, scrollTop);
        requestAnimationFrame(step);
      }
    };

    step();
  },
  UrlSearch: function (){
    var name;
    var value;
    var obj = {};
    var str = window.location.href;
    var num = str.indexOf('?');

    str = str.substr(num + 1);
    var arr = str.split('&');

    for (var i = 0; i < arr.length; i++){
      num = arr[i].indexOf('=');
      if (num > 0){
        name = arr[i].substring(0, num);
        value = arr[i].substr(num + 1);
        obj[name] = value;
      }
    }
    return obj;
  },
  serialize: function (params){
    if (!params){
      return '';
    }
    return Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
  },
  getLanguageRegion(){
    const regionMap = {
      en: 'GB',
      // 'zh': 'CN',
      nb: 'NO'
    };
    const langMap = {
      en: 'en',
      nb: 'nb',
      no: 'nb',
      nn: 'nb'
    };
    let lang = 'en';
    let region = 'GB';

    const language = navigator.language || 'en-GB';

    lang = language.split('-')[0] || 'en';
    region = regionMap[lang] || 'GB';

    if (!this.isInWebview()){
      lang = this.getQueryVariable('lang');
      region = this.getQueryVariable('region');
    }
    let newlang = langMap[lang] || 'en';

    return {
      lang: newlang,
      region
    };
  },

  getLangAndRegionFromLocale(locale) {
    if (locale === 'no_NO') {
      return { lang: 'nb', region: 'NO' }
    }
    const [lang, region] = locale.split('_')
    return {
      lang,
      region,
    }
  }
};
